export const getPlatformType = (platform: string | undefined): string => {
   if (!platform || typeof platform !== 'string') return 'Other'

   const platformLower = platform.toLowerCase()

   if (platformLower.includes('zoom')) {
      return 'Zoom'
   } else if (
      platformLower.includes('google') ||
      platformLower.includes('meet')
   ) {
      return 'Google Meet'
   } else if (
      platformLower.includes('phone') ||
      platformLower.includes('call')
   ) {
      return 'Phone Call'
   } else if (
      platformLower.includes('in-person') ||
      platformLower.includes('office') ||
      platformLower.includes('location')
   ) {
      return 'In-Person'
   } else {
      return 'Other'
   }
}
